var Isotope = require('isotope-layout')

/**
 * TreamentsGrid functionality.
 * @author We Are Duo
 */

export default class TreamentsGrid {
  /**
   * Constructs a new TreamentsGrid instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */

  constructor(options) {
    this.element = options.element
    this.grid = this.element.querySelector('.grid')

    const treatmentsGridIso = new Isotope(this.grid, {
      itemSelector: '.element-item',
      transitionDuration: 0,
    })

    // bind filter button click
    var filtersElem = document.querySelector('.filters-button-group')
    filtersElem.addEventListener('click', (event) => {
      var filterValue = event.target.getAttribute('data-filter')
      treatmentsGridIso.arrange({ filter: filterValue })
    })

    // change is-checked class on buttons
    var buttonGroups = document.querySelectorAll('.button-group')
    for (var i = 0, len = buttonGroups.length; i < len; i++) {
      var buttonGroup = buttonGroups[i]
      this.radioButtonGroup(buttonGroup)
    }
  }
  radioButtonGroup(buttonGroup) {
    buttonGroup.addEventListener('click', (event) => {
      buttonGroup.querySelector('.is-checked').classList.remove('is-checked')
      event.target.classList.add('is-checked')
    })
  }
}
